module.exports = "/_next/static/images/game-3-fingerprint-main-grey-2ad410d7f5ffbc2eb62f2a7d20e8897a.png";